import React from 'react';

const Contactus = () => {
  return (
    <div>
      <section className="section section-bg" id="call-to-action" style={{ backgroundImage: "url(assets/images/vvipgals.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="cta-content">
                <br />
                <br />
                <h2>Feel free to <em>Contact Us</em></h2>
                <p>You can contact us directly through on of the following platforms</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="features">
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-6 offset-lg-3">
              <div className="section-heading">
                <h2>contact <em> info</em></h2>
                <img src="assets/images/line-dec.png" alt="waves" />

              </div>
            </div>

            <div className="col-md-4">
              <div className="icon">
                <i className="fa fa-phone"></i>
              </div>

              <h5><a href="!#">+256 785 440728</a></h5>

              <br />
            </div>

            <div className="col-md-4">
              <div className="icon">
                <i className="fa fa-envelope"></i>
              </div>

              <h5><a href="!#">vip.mobilecoffeebar@gmail.com</a></h5>

              <br />
            </div>

            <div className="col-md-4">
              <div className="icon">
                <i className="fa fa-map-marker"></i>
              </div>

              <h5>Kampala</h5>

              <br />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
};

export default Contactus;
